import axios from "axios";
import { API_URL } from "../utils/constant";
import {
  USER_LOGGED_IN,
  USER_LOGGED_OUT,
  DASHBOARD_FETCHED,
  PASSWORD_RESET_REQUESTED,
  PASSWORD_RESET_DONE,
  TWO_FACTOR_ENABLED,
} from "./index";
import { toastr } from "react-redux-toastr";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

// import { toastr } from 'react-redux-toastr';

export const pingServer = () => (dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  if (session) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

    axios
      .get(`${API_URL}/ping`, {})
      .then((response) => {
        if (response.data.error) {
          dispatch({
            type: USER_LOGGED_OUT,
            payload: null,
          });

          toastr.error("Error", response.data.userMessage);
        } else {
          dispatch({
            type: USER_LOGGED_IN,
            payload: response.data.data,
          });
          // toastr.success("Success", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Server code : F0005";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        toastr.error("Error", message);

        dispatch({
          type: USER_LOGGED_OUT,
          payload: null,
        });
        // cookie.remove("session");
        localStorage.clear();
      });
  } else {
    dispatch({
      type: USER_LOGGED_OUT,
      payload: null,
    });
  }
};

export const dashboardAnalytics = (props) => (dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .get(`${API_URL}/dashboard`)
    .then((response) => {
      dispatch({
        type: DASHBOARD_FETCHED,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Server code : F0006";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: DASHBOARD_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const login = (props) => (dispatch) => {
  axios
    .post(`${API_URL}/login`, { ...props })
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        // const cookie = new Cookies();
        // cookie.set("session", response.data.data.token);
        if (response.data.twoFactor) {
          toastr.success("Success", response.data.otpMessage);
          dispatch({
            type: TWO_FACTOR_ENABLED,
            payload: response.data.data,
          });
        } else {
          localStorage.setItem("session", response.data.data.token);
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data.data.token}`;
          localStorage.setItem("user", JSON.stringify(response.data.data.user));
          //console.log("logged in", response.data.data)
          dispatch({
            type: USER_LOGGED_IN,
            payload: response.data.data.user,
          });
        }
      }
    })
    .catch((err) => {
      var message = "Server code : F0007";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      toastr.error("Error", message);
    });
};

export const verifyOTP = (props) => (dispatch) => {
  //console.log(props,'verifyOTP');
  // const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${props.token}`;
  axios
    .post(`${API_URL}/verifyOTP`, { authToken: props.token, otp: props.otp })
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        // const cookie = new Cookies();
        // cookie.set("session", response.data.data.token);
        localStorage.setItem("session", response.data.data.token);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.data.token}`;
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
        //console.log("logged in", response.data.data)
        dispatch({
          type: USER_LOGGED_IN,
          payload: response.data.data.user,
        });
      }
    })
    .catch((err) => {
      var message = "Server code : F0008";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      toastr.error("Error", message);
    });
};

export const forgotPassword = (props) => (dispatch) => {
  axios
    .post(`${API_URL}/forgot-password`, { ...props })
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
        dispatch({
          type: PASSWORD_RESET_REQUESTED,
          payload: response.data,
        });
      }
    })
    .catch((err) => {
      var message = "Server code : F0009";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      toastr.error("Error", message);
    });
};

export const resetPassword = (props) => (dispatch) => {
  //console.log(props,'props',dispatch,'dispatch')
  axios
    .post(
      `${API_URL}/${
        props.resetCode ? "reset-password/" + props.resetCode : "reset-password"
      }`,
      { ...props }
    )
    .then((response) => {
      //console.log("resetPassword")
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        // const cookie = new Cookies();
        // cookie.set("session", response.data.data.token);
        localStorage.setItem("session", response.data.data.token);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.data.token}`;
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
        toastr.success("Success", "Password updated.");
        window.location.href = "/summary";
        dispatch({
          type: PASSWORD_RESET_DONE,
          payload: response.data.data.user,
        });
      }
    })
    .catch((err) => {
      console.log("F0010 - ", err);
      var message = "Server code : F0010";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      toastr.error("Error", message);
    });
};

// const signInUserWithGoogleRequest = async () =>
//   await auth
//     .signInWithPopup(googleAuthProvider)
//     .then(authUser => authUser)
//     .catch(error => error);

export const googleSignIn = (props) => (dispatch) => {
  const auth = getAuth();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: "select_account",
  });
  signInWithPopup(auth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.idToken;
      // The signed-in user info.
      // const user = result.user;
      //console.log(token,"token")

      axios
        .post(`${API_URL}/google/login`, { token: token })
        .then((response) => {
          if (response.data.error) {
            toastr.error("Error", response.data.userMessage);
          } else {
            // if(user.email != props){
            //   toastr.error("Error", `Please use ${props} to login.`);
            // }else{
            // const cookie = new Cookies();
            // cookie.set("session", response.data.data.token);
            localStorage.setItem("session", response.data.data.token);
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${response.data.data.token}`;
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.data.user)
            );
            //console.log("logged in", response.data.data)
            dispatch({
              type: USER_LOGGED_IN,
              payload: response.data.data.user,
            });
            // }
          }
        })
        .catch((err) => {
          var message = "Server code : F0011";
          if (err.response) {
            message = err.response.data.userMessage;
          }
          toastr.error("Error", message);
        });
    })
    .catch((error) => {
      // Handle Errors here.
      // const errorCode = error.code;
      // const errorMessage = error.message;
      // The email of the user's account used.
      // const email = error.email;
      // The AuthCredential type that was used.
      // const credential = GoogleAuthProvider.credentialFromError(error);
      // ...
    });
};

export const logout = (dispatch) => {
  dispatch({
    type: USER_LOGGED_OUT,
    payload: null,
  });
};
